import { render, staticRenderFns } from "./CustomerContactFields.vue?vue&type=template&id=1776c8b7&scoped=true"
import script from "./CustomerContactFields.vue?vue&type=script&lang=js"
export * from "./CustomerContactFields.vue?vue&type=script&lang=js"
import style0 from "./CustomerContactFields.vue?vue&type=style&index=0&id=1776c8b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1776c8b7",
  null
  
)

export default component.exports